<h3>{{ idEnModification !== null ? ('admin.arch.modifierTitre' | traduire) : ('admin.arch.ajouter' | traduire) }}</h3>

<form class="form-ajout" (ngSubmit)="validerFormulaire()">
  <div class="ligne">
    <div>
      <label>{{ 'admin.arch.annee' | traduire }}</label>
      <input type="number" [(ngModel)]="formEdition.annee" name="annee" required>
    </div>
    <div>
      <label>{{ 'admin.arch.theme' | traduire }}</label>
      <input type="text" [(ngModel)]="formEdition.theme" name="theme" placeholder="Ex : Résonances d'Orient">
    </div>
  </div>

  <div class="ligne">
    <div>
      <label>{{ 'admin.arch.nbSpectacles' | traduire }}</label>
      <input type="number" [(ngModel)]="formEdition.nbSpectacles" name="nbSpectacles">
    </div>
    <div>
      <label>{{ 'admin.arch.nbSpectateurs' | traduire }}</label>
      <input type="number" [(ngModel)]="formEdition.nbSpectateurs" name="nbSpectateurs">
    </div>
  </div>

  <app-photo-uploader [label]="'admin.arch.photo' | traduire" [value]="formEdition.photoUrl" (valueChange)="formEdition.photoUrl = $event"></app-photo-uploader>
  <p class="confirmation" *ngIf="messageConfirmation">{{ messageConfirmation }}</p>

  <div class="boutons-form">
    <button type="submit">{{ idEnModification !== null ? ('admin.arch.enregistrerModifs' | traduire) : ('admin.arch.ajouterBtn' | traduire) }}</button>
    <button type="button" class="btn-annuler" *ngIf="idEnModification !== null" (click)="annulerModification()">{{ 'admin.arch.annuler' | traduire }}</button>
  </div>
</form>

<h3>{{ 'admin.arch.existantes' | traduire }}</h3>

<table class="table-liste">
  <thead>
    <tr>
      <th>{{ 'admin.arch.annee' | traduire }}</th>
      <th>{{ 'admin.arch.theme' | traduire }}</th>
      <th>{{ 'admin.arch.colSpectacles' | traduire }}</th>
      <th>{{ 'admin.arch.colSpectateurs' | traduire }}</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let edition of editions">
      <td>{{ edition.annee }}</td>
      <td>{{ edition.theme }}</td>
      <td>{{ edition.nbSpectacles }}</td>
      <td>{{ edition.nbSpectateurs }}</td>
      <td>
        <button class="btn-modifier" (click)="modifierEdition(edition)">{{ 'admin.arch.modifier' | traduire }}</button>
        <button class="btn-supprimer" (click)="supprimerEdition(edition)">{{ 'admin.arch.supprimer' | traduire }}</button>
      </td>
    </tr>
  </tbody>
</table>
